import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';
import { REPORT_STATUS } from '../constants/Enums';

const { PENDING, SUBMITTED, APPROVED, DENIED } = REPORT_STATUS;

const useTextExpenseFilters = () => {
  const { t } = useTranslation(i18nNS.tripExpense);

  const filters = [
    {
      label: t('ExpenseWidget.Pending'),
      value: PENDING,
    },
    {
      label: t('ExpenseWidget.Submitted'),
      value: SUBMITTED,
    },
    {
      label: t('ExpenseWidget.Approved'),
      value: APPROVED,
    },
    {
      label: t('ExpenseWidget.Denied'),
      value: DENIED,
    },
  ];

  return filters;
};

export default useTextExpenseFilters;
